/**
 *
 * This file was automatically generated using build-icons npm script and should not be edited
 *
 **/
import { createIcon } from "@cmp-src/icons/create-icon";
export const MinusIcon = createIcon({
  displayName: "MinusIcon",
  viewBox: "0 0 14 14",
  path: (
    <g fill="none">
      <path
        d="M11.6565 6.25V7.75H2.34277L2.34277 6.25H11.6565Z"
        fill="currentColor"
      />
    </g>
  )
});
